import store, { subscribe } from 'shared/store'
import { actionNames } from 'shared/store/ducks/userSession'
import toggleBoolStringAttr from 'views/utils/toggleBoolStringAttribute'
import { ARIA_HIDDEN } from 'views/assets/scripts/consts'

import buildClientAPI from 'views/providers/clientAPI'

const wishList = userSession => {
  const SELECTOR_WISHLIST_WRAPPER =
    '[data-clientside-hook~="o-BuyBoxWishList__wrapper"]'
  const SELECTOR_WISHLIST_BUTTON =
    '[data-clientside-hook~="o-BuyBoxWishList__button"]'
  const SELECTOR_WISHLIST_HEART_ICON =
    '[data-clientside-hook~="o-BuyBoxWishList__heart-icon"]'
  const SELECTOR_WISHLIST_HEART_FILLED_ICON =
    '[data-clientside-hook~="o-BuyBoxWishList__heartFilled-icon"]'
  const ADD_TO_WISHLIST_TOOLTIP =
    '[data-clientside-hook~="add-to-wishlist-tooltip"]'

  const wishlistWrapper = document.querySelector(SELECTOR_WISHLIST_WRAPPER)
  if (!wishlistWrapper) {
    return
  }
  const wishListLink = wishlistWrapper.querySelector(SELECTOR_WISHLIST_BUTTON)

  const tooltipTextContainer = document.querySelector(ADD_TO_WISHLIST_TOOLTIP)
  /** @type HTMLElement */
  const heartIcon = document.querySelector(SELECTOR_WISHLIST_HEART_ICON)
  /** @type HTMLElement */
  const heartFilledIcon = document.querySelector(
    SELECTOR_WISHLIST_HEART_FILLED_ICON
  )

  const { product, isLoggedIn } = userSession

  if (!isLoggedIn) return

  const {
    pageProperties: { pzn, category }
  } = store.getPublicRuntimeConfig()

  const options = {
    params: {
      productCode: pzn,
      categoryCode: category
    }
  }

  let { onNotepad } = product
  // to disable multiple click
  let isFetching = false

  const changeTooltipText = text => {
    tooltipTextContainer.textContent = text
  }
  const toggleIcons = isInWishlist => {
    toggleBoolStringAttr(heartFilledIcon, ARIA_HIDDEN, isInWishlist)
    toggleBoolStringAttr(heartIcon, ARIA_HIDDEN, !isInWishlist)
  }

  const updateNotepad = async () => {
    if (isFetching || !isLoggedIn) return
    isFetching = true
    const { clientFockService } = buildClientAPI()
    try {
      if (onNotepad) {
        // product is already in wishlist
        await clientFockService.deleteProductFromWishList(options)
        onNotepad = false
        toggleIcons(onNotepad)
      } else {
        // product is not in wishlist
        await clientFockService.addProductToWishList(options)
        onNotepad = true
        toggleIcons(onNotepad)
      }
    } catch (e) {
      // show tooltip only in the case of failure
      changeTooltipText('Etwas ist schief gelaufen, bitte laden Sie Seite neu')
      toggleBoolStringAttr(tooltipTextContainer, ARIA_HIDDEN, true)
    } finally {
      isFetching = false
    }
  }

  if (onNotepad) {
    toggleIcons(true)
  }

  wishListLink.addEventListener('click', () => {
    toggleBoolStringAttr(tooltipTextContainer, ARIA_HIDDEN, true)
  })

  wishListLink.addEventListener('click', updateNotepad)
}

export default () => {
  subscribe.after.once(actionNames.setUserSession, ({ userSession }) => {
    wishList(userSession)
  })
}
